export default "__VITE_ASSET__CgU4LcoJ__"